import Axios from "axios";
import { OpenAPI } from "../features/Api-legacy/type/openApi";

export function getBookingBackend(): string {
  // Check for runtime configuration first (on-premise)
  const runtimeUrl = (globalThis as any).REACT_APP_BOOKING_BACKEND_URL;

  // Debug logging
  // eslint-disable-next-line no-console
  console.log("🔍 getBookingBackend() called");
  // eslint-disable-next-line no-console
  console.log("🔍 runtimeUrl:", runtimeUrl, typeof runtimeUrl);
  // eslint-disable-next-line no-console
  console.log(
    "🔍 process.env.REACT_APP_BOOKING_BACKEND_URL:",
    process.env.REACT_APP_BOOKING_BACKEND_URL
  );

  if (runtimeUrl && typeof runtimeUrl === "string" && runtimeUrl.trim() !== "") {
    // eslint-disable-next-line no-console
    console.log("🔍 Using runtime URL:", runtimeUrl);
    return runtimeUrl;
  }

  // Fall back to build-time environment variable
  if (!process.env.REACT_APP_BOOKING_BACKEND_URL) {
    throw new Error("Booking Backend URL not configured!");
  }

  // eslint-disable-next-line no-console
  console.log("🔍 Using build-time URL:", process.env.REACT_APP_BOOKING_BACKEND_URL);
  return process.env.REACT_APP_BOOKING_BACKEND_URL;
}

export function getOrgBackend(): string {
  // Check for runtime configuration first (on-premise)
  const runtimeUrl = (globalThis as any).REACT_APP_ORG_BACKEND_URL;
  if (runtimeUrl && typeof runtimeUrl === "string" && runtimeUrl.trim() !== "") {
    return runtimeUrl;
  }

  // Fall back to build-time environment variable
  if (!process.env.REACT_APP_ORG_BACKEND_URL) {
    throw new Error("Org Backend URL not configured!");
  }

  return process.env.REACT_APP_ORG_BACKEND_URL;
}

// Function to initialize backend configuration
export function initializeBackendConfig(): void {
  let baseURL = "";
  if (process.env.REACT_APP_BOOKING_BACKEND_URL) {
    baseURL = process.env.REACT_APP_BOOKING_BACKEND_URL;
  }
  Axios.defaults.baseURL = baseURL;
  OpenAPI.BASE = baseURL.replace("/api", "");
}

// Initialize with build-time config, will be updated by runtime config if available
// This initialization is covered by tests that call initializeBackendConfig() directly
initializeBackendConfig();

// Function to update configuration when runtime config is loaded
export function updateBackendConfiguration(): void {
  const base = getBookingBackend();
  Axios.defaults.baseURL = base;
  OpenAPI.BASE = base.replace("/api", "");
}

// Export the function instead of calling it at module load time
export default getBookingBackend;
